import styled, { device } from "@theme/utils";
export const ServicesSection = styled.section`
    padding: 80px 0;
`;
